(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import axios from "axios";
import camelizeKeys from "../camelizeKeys";
import snakelizeKeys from "../snakelizeKeys";
import storage from "../../store/localStorage";
import { i18nInstance } from "../../modules/Translation";

const onError = error => {
  const errorResponse = {
    isTimeoutError: false
  };

  if (error.code === "ECONNABORTED") {
    errorResponse.isTimeoutError = true;
  } else if (error.response) {
    Object.assign(errorResponse, {
      errors: error.response.data,
      statusCode: error.response.status,
      isTimeoutError: false
    });
  } else {
    // invoke when something broken inside promise
    errorResponse.internalError = error; // eslint-disable-next-line

    console.error("axios.onError", error);
  }

  return Promise.reject(errorResponse);
};

const instance = axios.create({
  timeout: 15000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache, no-store, must-revalidate",
    Pragma: "no-cache"
  },
  transformRequest: [snakelizeKeys].concat(axios.defaults.transformRequest),
  transformResponse: axios.defaults.transformResponse.concat(camelizeKeys)
});
instance.interceptors.request.use(config => {
  return { ...config,
    params: snakelizeKeys(config.params),
    headers: { ...config.headers,
      userId: storage.get("userId"),
      language: i18nInstance.language
    }
  };
});
instance.interceptors.response.use(resp => resp, onError); // will be set from App props

instance.API_URL = null;
const _default = instance;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(onError, "onError", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/utils/axiosClient/axiosClient.js");
  reactHotLoader.register(instance, "instance", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/utils/axiosClient/axiosClient.js");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/utils/axiosClient/axiosClient.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();